<div class="m-section">
  <div class="m-section__sectionHeader">
    <span class="m-section__sectionIndex">{{ title() }}</span>
    @if (removeLabel()) {
      <button
        type="button"
        class="m-section__removeBtn"
        (click)="onRemove.emit($event)"
      >
        {{ removeLabel() }}
      </button>
    }
  </div>

  <ng-content></ng-content>
</div>

